import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Trash2, Mail, Phone, User, Calendar, Check, MessageSquare } from "lucide-react";

const STATUS_OPTIONS = [
  { value: "new", label: "Nouvelle", color: "bg-amber-100 text-amber-800" },
  { value: "contacted", label: "Contactée", color: "bg-sky-100 text-sky-800" },
  { value: "closed", label: "Clôturée", color: "bg-emerald-100 text-emerald-800" },
];

const fmtDate = (d) => d ? new Date(d).toLocaleString("fr-FR") : "—";

const LevelRequestsAdmin = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/level-requests");
      setItems(data || []);
    } catch { toast.error("Erreur de chargement"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/admin/level-requests/${id}`, { status });
      toast.success("Statut mis à jour");
      load();
    } catch { toast.error("Erreur"); }
  };

  const del = async (id) => {
    if (!window.confirm("Supprimer cette demande ?")) return;
    try {
      await api.delete(`/admin/level-requests/${id}`);
      toast.success("Supprimée");
      load();
    } catch { toast.error("Erreur"); }
  };

  return (
    <div>
      <h1 className="font-serif-display text-2xl sm:text-3xl text-stone-800">Demandes de niveau</h1>
      <p className="text-stone-500 mt-1 text-sm sm:text-base">Demandes envoyées par les parents qui ne savent pas dans quel cours inscrire leur enfant.</p>

      {loading ? <div className="text-stone-500 p-8 text-center">Chargement...</div> : items.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 text-center text-stone-500 mt-6">Aucune demande pour le moment.</div>
      ) : (
        <div className="space-y-3 mt-6">
          {items.map((r) => {
            const st = STATUS_OPTIONS.find((s) => s.value === r.status) || STATUS_OPTIONS[0];
            return (
              <div key={r.id} className="bg-white rounded-2xl shadow-sm p-5">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
                      <span className="font-serif-display text-stone-800 text-lg">
                        <User size={14} className="inline mr-1"/> {r.parentName}
                      </span>
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs ${st.color}`}>{st.label}</span>
                    </div>
                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-stone-500 mt-1">
                      <a href={`mailto:${r.email}`} className="hover:text-deep-rose"><Mail size={13} className="inline mr-1"/>{r.email}</a>
                      {r.phone && <a href={`tel:${r.phone}`} className="hover:text-deep-rose"><Phone size={13} className="inline mr-1"/>{r.phone}</a>}
                      <span className="text-stone-400"><Calendar size={13} className="inline mr-1"/>{fmtDate(r.createdAt)}</span>
                    </div>
                  </div>
                  <button onClick={() => del(r.id)} className="p-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-600 shrink-0"><Trash2 size={16}/></button>
                </div>

                <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                  <div className="bg-cream rounded-xl p-3">
                    <div className="text-xs uppercase tracking-widest text-stone-500 mb-1">Enfant</div>
                    <div className="text-stone-700">{r.childName} {r.childAge && <span className="text-stone-500">({r.childAge} ans)</span>}</div>
                  </div>
                  <div className="bg-cream rounded-xl p-3">
                    <div className="text-xs uppercase tracking-widest text-stone-500 mb-1">Expérience préc.</div>
                    <div className="text-stone-700">{r.previousExperience || "—"}</div>
                  </div>
                </div>
                <div className="mt-3 bg-stone-50 rounded-xl p-3 text-sm text-stone-700">
                  <div className="text-xs uppercase tracking-widest text-stone-500 mb-1"><MessageSquare size={12} className="inline mr-1"/> Message</div>
                  <div className="whitespace-pre-wrap">{r.message}</div>
                </div>
                <div className="flex gap-2 mt-3 flex-wrap">
                  {STATUS_OPTIONS.filter((s) => s.value !== r.status).map((s) => (
                    <button key={s.value} onClick={() => updateStatus(r.id, s.value)} className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs bg-stone-100 hover:bg-stone-200 text-stone-700">
                      <Check size={12}/> Marquer {s.label.toLowerCase()}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LevelRequestsAdmin;
